$(document).ready(function(){
    $('.content-gallery').slick({
        rows: 0,
        slidesToShow: 1,
        dots: true,
        arrows: false
    });
});